"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getStateContentType(offerType) {
    switch (offerType) {
        case 'course':
            return entity_1.StateContentType.OFFER;
        default:
            return offerType;
    }
}
exports.getStateContentType = getStateContentType;
//# sourceMappingURL=getStateContentType.js.map